export enum UserRole {
  Admin = 'ADMIN',
  User = 'USER',
  SuperAdmin = 'SUPERADMIN'
}

export enum UserType {
  Internal = 'INTERNAL',
  Customer = 'CUSTOMER'
}

export enum UserJob {
  DESIGNER = 'DESIGNER',
  MARKETER = 'MARKETER',
  DEVELOPER = 'DEVELOPER',
  TEAMLEADER = 'TEAMLEADER',
  SALES = 'SALES'
}

export enum UserJobWithoutTeamleader {
  DESIGNER = UserJob.DESIGNER,
  MARKETER = UserJob.MARKETER,
  DEVELOPER = UserJob.DEVELOPER,
  SALES = UserJob.SALES
}

export interface UserInformationResponseDto {
  userRole: UserRole;
  userType: UserType;
  profilePictureUrl: string;
  isTeamLeader?: boolean;
  userJobs: UserJob[];
}

export enum InvitationStatusEnum {
  INVITED = 'eingeladen'
}

// export interface UserInfoResponseDto {
//   userType: UserTypeEnum;
//   userRole: UserRoleEnum;
// }

export interface IUser {
  _id: string;
  firstName: string;
  lastName: string;
  mail: string;
  status: InvitationStatusEnum;
}

export interface UserSelectableEntityResponseDto {
  _id: string;
  value: string;
}

export interface UserProfileResponseDto {
  _id: string;
  firstName: string;
  lastName: string;
  mail: string;
  profilePictureUrl: string;
  appNotificationChatEnabled: boolean;
  appNotificationStatusEnabled: boolean;
  appNotificationNewJobEnabled: boolean;
  appNotificationFinalUrlEnabled: boolean;
  appNotificationRatingEnabled: boolean;
  mailNotificationChatEnabled: boolean;
  mailNotificationStatusEnabled: boolean;
  mailNotificationNewJobEnabled: boolean;
  mailNotificationFinalUrlEnabled: boolean;
  mailNotificationRatingEnabled: boolean;
  pseudoName?: string;
}

export const userRoleMapping: Record<UserRole, string> = {
  [UserRole.Admin]: 'Admin',
  [UserRole.User]: 'Benutzer',
  [UserRole.SuperAdmin]: 'Superadmin'
};

export const userRoleBadgeColor: Record<UserRole, string> = {
  [UserRole.Admin]: 'text-green-600 border-green-400 bg-green-50 px-2 py-1',
  [UserRole.User]: 'text-gray-600 border-gray-400 bg-gray-50 px-2 py-1',
  [UserRole.SuperAdmin]: 'text-red-600 border-red-400 bg-red-50 px-2 py-1'
};
